var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrvlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8284ad;\n      }\n\n      .cls-2 {\n        fill: #a7a8c5;\n      }\n\n      .cls-3 {\n        fill: #8cceef;\n      }\n\n      .cls-4 {\n        fill: #00a7e1;\n      }\n\n      .cls-5 {\n        fill: #545a8e;\n      }\n\n      .cls-6 {\n        fill: #001f60;\n      }\n\n      .cls-7 {\n        fill: #56bde9;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m65.61,182.51l-43.67-43.17,53.86-57.5v-46.23h-4.87V14.73h63.79v20.87h-4.87v46.26l53.87,57.47-43.68,43.17h-74.43Zm65.83-20.86l22.72-22.33-45.17-48.82v-54.87h-12.33v54.85s-45.17,48.83-45.17,48.83l22.73,22.33h57.22Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.99 90.5 129.85 81.87 154.16 139.31 108.99 90.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.85 81.87 154.16 139.31 183.72 139.31 129.85 81.87"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "96.67 90.48 75.8 81.83 51.5 139.31 96.67 90.48"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.8 81.83 21.94 139.31 51.5 139.31 75.8 81.83"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.8 44.07 96.67 90.48 75.8 81.83 75.8 44.07"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.85 44.07 108.99 90.5 129.85 81.87 129.85 44.07"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "44.51 161.64 161.15 161.64 65.61 182.51 44.51 161.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.61 182.51 140.05 182.51 44.51 161.64 65.61 182.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.51 161.64 65.61 182.51 102.83 174.38 44.51 161.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.83 174.38 161.15 161.64 140.05 182.51 102.83 174.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "131.44 161.64 161.15 161.64 154.16 139.31 131.44 161.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.16 139.31 183.72 139.31 161.15 161.64 154.16 139.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.22 161.64 51.5 139.31 44.51 161.64 74.22 161.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "51.5 139.31 21.94 139.31 44.51 161.64 51.5 139.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.93 14.73 134.73 14.73 70.93 35.61 70.93 14.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "70.93 14.73 134.73 35.61 70.93 35.61 70.93 14.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "70.93 35.61 102.83 25.17 70.93 14.73 70.93 35.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.73 14.73 102.83 25.17 134.73 35.61 134.73 14.73"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.8 44.07 96.67 35.63 75.8 35.63 75.8 44.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.99 35.63 129.85 44.07 129.85 35.61 108.99 35.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.67 90.48 75.8 81.83 67.72 100.94 96.67 90.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.99 90.48 129.86 81.83 137.94 100.94 108.99 90.48"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrvlogo);
export default __webpack_public_path__ + "static/media/mrvlogo.574f3dc26fdee7d7ec74e566f47b8784.svg";
export { ForwardRef as ReactComponent };